var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c("div", { staticClass: "row q-mb-sm" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c(
            "div",
            { staticClass: "q-display-1 text-secondary" },
            [
              _c("q-icon", {
                staticClass: "q-mb-sm",
                attrs: { name: "fas fa-podcast" }
              }),
              _vm._v(
                " " + _vm._s(_vm.$t(_vm.title_podcasts)) + "\n            "
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "q-tabs",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "basic-data",
              label: _vm.$t("basic_data")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: { slot: "title", name: "audios", label: _vm.$t("audios") },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTab,
                expression: "showTab"
              }
            ],
            attrs: {
              slot: "title",
              name: "configure_and_publish",
              label: _vm.$t("configure_and_publish")
            },
            slot: "title"
          }),
          _vm.useCommentsPodcast
            ? _c("q-tab", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTab,
                    expression: "showTab"
                  }
                ],
                attrs: {
                  slot: "title",
                  name: "comments",
                  label: _vm.$t("comments")
                },
                slot: "title"
              })
            : _vm._e(),
          _c(
            "q-tab-pane",
            { attrs: { name: "basic-data" } },
            [
              _c("basic-data", {
                attrs: { managePodcasts: _vm.permissions.podcasts_manage }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "audios" } },
            [
              _c("audios", {
                attrs: { managePodcasts: _vm.permissions.podcasts_manage }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "configure_and_publish" } },
            [
              _c("configure-and-publish", {
                attrs: { managePodcasts: _vm.permissions.podcasts_manage },
                on: { duplicate: _vm.changeTab }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "comments" } },
            [_c("comments", { attrs: { origin: "podcast" } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }